module.exports = __webpack_public_path__ + "static/media/tooltip.039858ab.svg";